"use client";

import { c as _c } from "react/compiler-runtime";
import { Twitter, Facebook, Instagram, Linkedin, Youtube, Globe, type LucideIcon } from "lucide-react";
import { BrandedHeader } from "@/components/branded/headers/BrandedHeader";
import type { ResolvedHeaderColors } from "@/features/theme/resolveBrandedStyle";
import type { Author } from "@/payload-types";
import { useLabels } from "@/lib/labels/LabelsProvider";
const PLATFORM_ICONS: Record<string, LucideIcon> = {
  twitter: Twitter,
  facebook: Facebook,
  instagram: Instagram,
  linkedin: Linkedin,
  youtube: Youtube,
  tiktok: Globe,
  website: Globe
};
interface AuthorHeaderProps {
  author: Author;
  headerColors?: ResolvedHeaderColors;
}
export function AuthorHeader(t0) {
  const $ = _c(12);
  const {
    author,
    headerColors
  } = t0;
  const labels = useLabels();
  const avatarUrl = author.avatar && typeof author.avatar !== "number" ? author.avatar.url ?? undefined : undefined;
  const t1 = author.bio ?? "";
  const t2 = headerColors?.colors;
  const t3 = headerColors?.backgroundImageUrl;
  let t4;
  if ($[0] !== author.name || $[1] !== avatarUrl || $[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
    t4 = <BrandedHeader titleAs="h1" title={author.name} subtitle={t1} imageUrl={avatarUrl} colors={t2} backgroundImageUrl={t3} />;
    $[0] = author.name;
    $[1] = avatarUrl;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== author.socialLinks || $[7] !== labels) {
    t5 = author.socialLinks && author.socialLinks.length > 0 && <div className="border-b border-border bg-card"><div className="max-w-350 mx-auto px-4 py-4 flex justify-center gap-4" aria-label={labels.authorPage.socialLinks}>{author.socialLinks.map(_temp)}</div></div>;
    $[6] = author.socialLinks;
    $[7] = labels;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function _temp(link, i) {
  const Icon = PLATFORM_ICONS[link.platform ?? ""] ?? Globe;
  return <a key={link.id ?? i} href={link.url ?? "#"} target="_blank" rel="noreferrer noopener" className="text-muted-foreground hover:text-foreground transition-colors"><Icon size={20} /></a>;
}